import { createContext,useContext,useEffect,useState } from 'react';
import { api } from '../lib/api';
const Context=createContext(null);
export const AuthProvider=({children})=>{
 const [user,setUser]=useState(null),[loading,setLoading]=useState(true);
 useEffect(()=>{if(window.location.hash.includes('session_id=')){setLoading(false);return;}api.get('/auth/session-state').then(r=>setUser(r.data.user)).catch(()=>setUser(null)).finally(()=>setLoading(false));},[]);
 const logout=async()=>{await api.post('/auth/logout');setUser(null);};
 return <Context.Provider value={{user,setUser,loading,logout}}>{children}</Context.Provider>;
};
export const useAuth=()=>useContext(Context);